/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */

import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';

const userIsAuthenticatedDefaults = {
  authenticatedSelector: state => state.user !== null,
  wrapperDisplayName: 'UserIsAuthenticated'
};

export const userIsAuthenticated = connectedAuthWrapper(userIsAuthenticatedDefaults);
//
// const userIsNotAuthenticatedDefaults = {
//     // Want to redirect the user when they are done loading and authenticated
//     authenticatedSelector: state => state.user === null,
//     wrapperDisplayName: 'UserIsNotAuthenticated'
// };
//
// export const userIsNotAuthenticated = connectedAuthWrapper(userIsNotAuthenticatedDefaults);

export const authenticatedOrElse = (Component, FailureComponent) => connectedAuthWrapper({
  authenticatedSelector: state => state.user !== null,
  wrapperDisplayName: 'AuthenticatedOrElse',
  FailureComponent
})(Component);

/**
 * Authentication wrapper that displays a component if the user is an admin (has the 'CAN_SEARCH_ALL' permission).
 * or displays an alternative component if the user is not an admin.
 *
 * @param Component the component to display if the user is an admin; never undefined or null.
 * @param FailureComponent a optional component to display if the user is NOT an admin.
 */
export const adminOrElse = (Component, FailureComponent) => connectedAuthWrapper({
  authenticatedSelector: state => state.user !== null && state.user.isAdmin,
  wrapperDisplayName: 'AdminOrElse',
  FailureComponent
})(Component);

/**
 * Authentication wrapper that displays a component if the user is an admin (has the 'CAN_SEARCH_ALL' permission).
 *
 * @param Component the component to display if the user is an admin; never undefined or null.
 */
export const adminOnly = connectedAuthWrapper({
  authenticatedSelector: state => state.user !== null && state.user.isAdmin,
  wrapperDisplayName: 'VisibleOnlyAdmin'
});

/**
 * Authentication wrapper that determines if the user not authenticated OR
 *  if the user is authenticated and is an eldap user
 *
 */
export const unauthenticatedOrEldap = connectedAuthWrapper({
    authenticatedSelector: state => state.user == null || (state.user !== null && state.user.isEldap),
    wrapperDisplayName: 'unauthenticatedOrEldap'
});




// WEBPACK FOOTER //
// ./src/auth/auth.js